import {HttpHeaders} from '@angular/common/http';
import {
  Configuration,
  GetMediaFilesResponse,
  MediaAdministrationServiceInterface,
  MediaFileForm,
  MediaLanguagesResponse,
  MultipartFormDataInput,
  Response
} from '@gt-api';
import {Observable, of} from 'rxjs';

export class MediaAdministrationServiceStub implements MediaAdministrationServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  getServiceNumberMediaFiles1(
    serviceNumber: string,
    organization?: string,
    login?: string,
    extraHttpRequestParams?: any
  ): Observable<GetMediaFilesResponse> {
    return of({});
  }

  uploadMultipartForm1(organization?: string, login?: string, body?: MediaFileForm, extraHttpRequestParams?: any): Observable<Response> {
    return of({});
  }

  uploadMultipartFormDataInput1(
    organization?: string,
    login?: string,
    body?: MultipartFormDataInput,
    extraHttpRequestParams?: any
  ): Observable<Response> {
    return of({});
  }

  getOrganizationMediaFiles1(organization?: string, login?: string, fileName?: string) {
    return of({
      code: 200,
      mediaFiles: [
        {
          fileName: '../Bedriftens_VMS.wav',
          displayName: 'Talepostkasse',
          description: 'Standardmelding talepostkasse',
          category: 105,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../menu.wav',
          displayName: 'Menymelding',
          description: 'Standard menymelding',
          category: 107,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../officeclosed.wav',
          displayName: 'Stengtmelding',
          description: 'Standard stengtmelding',
          category: 101,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../overflow.wav',
          displayName: 'Ikke besvart',
          description: 'Standard talemelding for ikke besvarte samtaler',
          category: 104,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../periodical.wav',
          displayName: 'Periodisk talemelding',
          description: 'Standard periodisk talemelding',
          category: 103,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../qmusic.wav',
          displayName: 'Kømusikk',
          description: 'Standard kømusikk',
          category: 102,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../ringingtone.wav',
          displayName: 'Ringetone',
          description: 'Standard ringetone',
          category: 102,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../ringingtone60.wav',
          displayName: 'Ringetone 60 sekunder',
          description: 'Standard ringetone 60 sekunder',
          category: 102,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../Stengt_call_back_during_openinghrs.wav',
          displayName: 'Stengt – Ring tilbake i åpningstiden',
          description: 'Opplyser kunde om at bedriften er stengt, og oppfordrer til å ringe tilbake i åpningstiden',
          category: 101,
          length: 0,
          uploadTime: new Date(1597839708000)
        },
        {
          fileName: '../Stengt_Ferie.wav',
          displayName: 'Stengt pga ferie',
          description: 'Opplyser om at bedriften er stengt pga ferie, og ser frem til å høre fra kunden etter ferien',
          category: 101,
          length: 0,
          uploadTime: new Date(1597839708000)
        },
        {
          fileName: '../Stengt_Sykdom.wav',
          displayName: 'Stengt pga sykdom',
          description: 'Vi er dessverre stengt pga sykdom. Prøv oss gjerne igjen i morgen',
          category: 101,
          length: 0,
          uploadTime: new Date(1597839708000)
        },
        {
          fileName: '../Stengt_try_again_tomorrow.wav',
          displayName: 'Stengt – Prøv igjen i morgen',
          description: 'Oppfordrer kunde til å ringe tilbake i morgen',
          category: 101,
          length: 0,
          uploadTime: new Date(1597839708000)
        },
        {
          fileName: '../welcome.wav',
          displayName: 'Velkomstmelding',
          description: 'Standard velkomstmelding',
          category: 100,
          length: 0,
          uploadTime: new Date(1553265167000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/new Date(15m_brownian.wav',
          displayName: '15m',
          description: 'brownian noice',
          category: 200,
          length: 9687062,
          uploadTime: new Date(1592037253000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/1hr_brownian.wav',
          displayName: '38mb',
          description: 'such wow',
          category: 200,
          length: 38748023,
          uploadTime: new Date(1591987148000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/file1MG.wav',
          displayName: 'Test 11062020',
          description: 'Test_11062020',
          category: 200,
          length: 1073218,
          uploadTime: new Date(1591880243000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/FullQueue.wav',
          displayName: 'FullQueue',
          description: 'FullQueue',
          category: 200,
          length: 958542,
          uploadTime: new Date(1593100456000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/FullQueueFw.wav',
          displayName: 'FullQueueFw',
          description: 'FullQueueFw',
          category: 200,
          length: 835662,
          uploadTime: new Date(1593100466000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/FwNoSuccess.wav',
          displayName: 'FwNoSuccess',
          description: 'FwNoSuccess',
          category: 200,
          length: 1192014,
          uploadTime: new Date(1593100476000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/hqmusic.wav',
          displayName: 'hqmusic',
          description: 'Queue music',
          category: 200,
          length: 1297472,
          uploadTime: new Date(1588110806000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/Ingenagenter.wav',
          displayName: 'Ingenagenter',
          description: 'Ingenagenter',
          category: 200,
          length: 1241166,
          uploadTime: new Date(1593092270000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/Ingenagenterfw.wav',
          displayName: 'Ingenagenterfw',
          description: 'Ingenagenterfw',
          category: 200,
          length: 1105998,
          uploadTime: new Date(1593100861000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/LongWaitingTime.wav',
          displayName: 'LongWaitingTime',
          description: 'LongWaitingTime',
          category: 200,
          length: 1056846,
          uploadTime: new Date(1593100484000)
        },
        {
          fileName: '../VOLTE_GINTEL_STAGING/LongWaitingTimeFw.wav',
          displayName: 'LongWaitingTimeFw',
          description: 'LongWaitingTimeFw',
          category: 200,
          length: 1040462,
          uploadTime: new Date(1593100494000)
        }
      ]
    });
  }

  editMediaMetadata1(organization?: string, login?: string, fileName?: string) {
    return of({});
  }

  downloadMediaFile1(organization?: string, login?: string, fileName?: string) {
    return of({});
  }

  deleteMediaFile1(organization?: string, login?: string, fileName?: string) {
    return of({});
  }

  getMediaLanguages1(organization?: string, login?: string, extraHttpRequestParams?: any): Observable<MediaLanguagesResponse> {
    return of({});
  }
}
